<h2 *ngIf="title" class="tt-detail-section__title" [id]="resolvedHeadingId">{{ title }}</h2>
<div class="tt-detail-fields">
  <div
    *ngFor="let item of visibleItems; trackBy: trackItem"
    class="detail-item"
    [class.detail-item--wide]="!!item.wide"
  >
    <span class="tt-detail-label">{{ item.label }}</span>
    <p class="tt-detail-value">{{ formatValue(item.value) }}</p>
  </div>
  <ng-content select="app-detail-item"></ng-content>
</div>
<ng-content></ng-content>
